.page {
  grid-column: 1 / -1;
  grid-row: 1 / -1;
  display: flex;
  flex-direction: column;
  gap: var(--gap);
  min-width: 0;
  min-height: 0;
  overflow-y: auto;
}

.head {
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  gap: 12px;
  min-width: 0;
  padding: 14px 16px;
}

.top {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.badge {
  display: grid;
  place-items: center;
  flex: 0 0 auto;
  width: 40px;
  height: 40px;
  border: 1px solid var(--accent-line);
  border-radius: var(--radius-chip);
  background: var(--accent-w);
  color: var(--accent);
}

.titles {
  display: flex;
  flex: 1 1 auto;
  align-items: baseline;
  gap: 10px;
  min-width: 0;
}

.label {
  color: var(--muted);
  font-size: var(--t-dense);
  font-weight: 600;
}

.actions {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 8px;
}

/* The key facts: a row of label over value, divided by hairlines. */
.facts {
  display: flex;
  flex-wrap: wrap;
  margin: 0;
  border: 1px solid var(--line);
  border-radius: var(--radius-chip);
  background: var(--panel-2);
}

.fact {
  display: flex;
  flex: 1 1 140px;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
  padding: 8px 12px;
  border-left: 1px solid var(--line);
}

.fact:first-child {
  border-left: 0;
}

.fact dt {
  color: var(--muted);
  font-size: var(--t-min);
  font-weight: 600;
}

/* A value with a chip beside it and a value without one start on the same line: every value is one
   row of the same height, centred (alignment audit, 2026-11-03). */
.fact dd {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 2px 6px;
  min-height: 24px;
  margin: 0;
  color: var(--ink);
  font-size: var(--t-body);
  font-variant-numeric: lining-nums tabular-nums;
  overflow-wrap: anywhere;
}

.mono {
  font-family: var(--mono);
  font-size: var(--t-dense);
}

.path {
  min-width: 0;
}

.columns {
  display: grid;
  flex: 1 0 auto;
  grid-template-columns: minmax(0, 1fr);
  gap: var(--gap);
  min-width: 0;
}

.withRail {
  grid-template-columns: minmax(0, 1fr) 320px;
}

.main {
  display: flex;
  flex-direction: column;
  gap: var(--gap);
  min-width: 0;
}

.main:focus-visible {
  outline: 2px solid var(--focus);
  outline-offset: 2px;
  border-radius: var(--radius-card);
}

.rail {
  display: flex;
  flex-direction: column;
  gap: var(--gap);
  min-width: 0;
}

.card {
  padding: 12px 14px;
}

.cardTitle {
  margin: 0 0 8px;
  color: var(--ink);
  font-size: var(--t-head);
  font-weight: 650;
}

/* Two columns down to 900px, where the rail stacks under the page (KD's design review). */
@media (max-width: 900px) {
  .withRail {
    grid-template-columns: minmax(0, 1fr);
  }
}

/* The headline number: 28px, weight 700. The unit keeps the case it was written in. */
.figure {
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  align-items: flex-end;
  gap: 0;
  min-width: 0;
}

.figureLabel {
  color: var(--muted);
  font-size: var(--t-min);
  font-weight: 600;
  line-height: 16px;
  text-transform: none;
}

.figureValue {
  color: var(--ink);
  font-size: 28px;
  font-weight: 700;
  letter-spacing: -0.02em;
  line-height: 34px;
}

.figureUnit {
  margin-left: 6px;
  color: var(--muted);
  font-size: var(--t-dense);
  font-weight: 500;
  letter-spacing: 0;
  text-transform: none;
}

.meter {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  min-width: 0;
}

/* The evidence chain folded under the path is one disclosure line across the header. */
.meter > * {
  flex: 1 1 auto;
  min-width: 0;
}
